import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/supabase';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

/**
 * Whether the build was given its Supabase credentials.
 *
 * These are baked in at build time, so a build run without them produces a
 * client pointed at '' where every auth call fails — indistinguishable from
 * being logged out, with only a console warning to explain it. main.tsx turns
 * that into a visible message. See docs/deployment.md.
 */
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.warn('Missing Supabase environment variables. Please check your .env file.');
}

// Placeholders keep createClient from throwing at module load when the build
// was run without credentials. Without them the whole bundle dies on import
// and the user gets a blank white page — the very symptom isSupabaseConfigured
// exists to replace with a readable message in main.tsx.
export const supabase = createClient<Database>(
  supabaseUrl || 'https://unconfigured.invalid',
  supabaseAnonKey || 'unconfigured',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true
    }
  }
);
